import ConfirmRegistrationView from './ConfirmRegistration.view';
export * from './ConfirmRegistration.view';

export const ConfirmRegistration = (props) => ConfirmRegistrationView(props);

export default ConfirmRegistration;

